import ReplySuggestionsPlaceholder from './ReplySuggestionsPlaceholder.component';

export default ReplySuggestionsPlaceholder;
